import { AlumniProfileModel } from '@/models/alumni-profile/alumni-profile.model';
import { UndergradLesson } from '@/models/undergrad/undegrad-lesson.model';
import { UndergradVideo } from '@/models/undergrad/undegrad-video.model';
import { NoteTextModel, SetTextPayloadModel } from './text.model';
import { UndergradDiscipline } from '@/models/undergrad/undergrad-discipline.model';

export enum NotePlatform {
  dex = 'dex',
  undergrad = 'undergrad',
}

export interface DexVideoModel {
  id: number;
  name: string;
}

export interface DexLessonModel {
  id: number;
  name: string;
  slug: string;
}

export interface DexDisciplineModel {
  id: number;
  name: string;
  slug: string;
}

type DisciplineNote = Pick<UndergradDiscipline, 'id' | 'name' | 'slug'>;

type LessonNote = Pick<UndergradLesson, 'id' | 'name' | 'slug'>;

type VideoNote = Pick<UndergradVideo, 'id' | 'name'>;

export interface NoteModel {
  id: number;
  profileId: number;
  videoId: string;
  lessonId?: string;
  draft?: NoteTextModel;
  latestText: NoteTextModel;
  platform?: NotePlatform;
  videoTimeStamp: number;
  originUrl?: string | null;
  createdAt?: Date;
  deletedAt?: Date;
  dexVideo?: DexVideoModel;
  dexLesson?: DexLessonModel;
  dexDiscipline?: DexDisciplineModel;
  profile?: Partial<AlumniProfileModel>;

  /* NEW MODEL */
  disciplineId?: string;
  discipline?: DisciplineNote;
  lesson?: LessonNote;
  video?: VideoNote;
}

export interface GroupedVideoModel {
  video: string;
  notes: NoteModel[];
}

export interface GroupedLessonModel {
  lesson: string;
  videos: GroupedVideoModel[];
}

export interface GroupedNotesModel {
  discipline: string;
  lessons: GroupedLessonModel[];
  totalNotes: number;
}

export interface SetNotePayloadModel {
  id?: number;
  videoId: string;
  text: SetTextPayloadModel;
  platform?: NotePlatform;
  videoTimeStamp: number;
  deletedAt?: Date;
  lessonId?: string;
  disciplineId?: string;
  originUrl?: string;
  saveNoteToClass?: boolean;
}
